import RichText from '@/components/RichText'
import { cn } from '@/utilities/ui'

import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

export type ImportantTextBlockProps = {
  title?: string | null
  content: DefaultTypedEditorState
  color?: ('evergreen' | 'tuscany') | null
  id?: string | null
  blockName?: string | null
  blockType: 'importantText'
}

export const ImportantTextBlock: React.FC<ImportantTextBlockProps> = ({
  title,
  content,
  color,
}) => {
  return (
    <div
      className={cn(
        'col-start-2 mx-auto my-4 flex flex-col gap-4 rounded-xl border-[2.5px] p-5 md:p-6',
        color === 'evergreen'
          ? 'border-evergreen-600 bg-evergreen-50'
          : 'border-tuscany-600 bg-tuscany-50',
      )}
    >
      <p
        className={cn(
          'text-lg leading-none font-bold tracking-wide uppercase',
          color === 'evergreen' ? 'text-evergreen-600' : 'text-tuscany-600',
        )}
      >
        {title}
      </p>
      <RichText data={content} className="font-body text-foreground" />
    </div>
  )
}
